import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { GeneralService } from '../Services/general.service';
import { SpaContext } from '../Classes/spacontext';
import { TranslateService } from '../Common/Services/translate.service';

interface ConfirmationModel {
	number: string;
	code: string;
}

@Component({
	standalone: false,
	selector: 'visiba-confirm-phone-number',
	template: `
		<visiba-svg *ngIf="loading" a="Loader"></visiba-svg>
		<ng-container *ngIf="!loading">
			<h2>{{ 'LicenceHolder.Component.ConfirmPhoneNumber.Title' | translate }}</h2>
			<form novalidate (ngSubmit)="sendConfirmationCode()" #codeform="ngForm" trapFocus>
				<div class="row codeSent">
					{{ 'LicenceHolder.Component.SmsLoginComponent.Phrase.CodeSent' | translate: { number: model.number } : 1 }}
				</div>
				<div class="row codeField">
					<visiba-input
						required
						maxlength="6"
						type="text"
						[(ngModel)]="model.code"
						name="code"
						placeholder="LicenceHolder.Component.SmsLoginComponent.Placeholder.YourCode"
					></visiba-input>
				</div>
				<div class="row error" *ngIf="errorMessage != null">{{ errorMessage }}</div>
				<div class="row codeAgain">
					<a (click)="verifyPhoneNumber()">{{ 'LicenceHolder.Component.SmsLoginComponent.Button.GetSmsCode' | translate }}</a>
				</div>
				<div class="row sendButton">
					<button class="btn large" [disabled]="!codeform.form.valid">{{ 'Common.Word.Confirm' | translate }}</button>
				</div>
			</form>
		</ng-container>
	`,
	styles: ['.sendButton {margin-top: 15px;} visiba-svg { width: 60px; }'],
})
export class ConfirmPhoneNumberComponent implements OnInit {
	@Input('phoneNumber') public phoneNumber: string;
	@Input('countryCode') public countryCode: string;
	@Input('languageCode') public languageCode: string;

	@Output() public onNumberConfirmed = new EventEmitter<string>();
	public errorMessage: string | null = null;
	public loading = true;
	public model: ConfirmationModel = { number: '', code: '' };
	private verificationAttemptId: string | null = null;
	private smsTries: number = 0;

	constructor(
		private generalService: GeneralService,
		private spaContext: SpaContext,
		private translateService: TranslateService,
	) {}

	ngOnInit() {
		this.model.number = this.phoneNumber;
		this.verifyPhoneNumber();
	}

	public verifyPhoneNumber() {
		if (this.smsTries > 2) return false;

		this.smsTries++;
		this.loading = true;

		this.generalService
			.verifyPhoneNumber(this.spaContext.unitConfig.LicenceHolder.Id, this.model.number, this.countryCode, this.languageCode)
			.subscribe(
				(response) => {
					this.verificationAttemptId = response.data.VerificationAttemptId;
					this.loading = false;
				},
				(error) => {
					this.errorMessage = this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Phrase.UnableToGetCode');
					this.loading = false;
				},
			);
	}

	sendConfirmationCode() {
		this.loading = true;

		this.generalService
			.completePhoneNumberVerification(this.spaContext.unitConfig.LicenceHolder.Id, this.verificationAttemptId, this.model.code)
			.subscribe(
				(response) => {
					this.onNumberConfirmed.emit(this.verificationAttemptId);
					this.loading = false;
				},
				(error) => {
					this.loading = false;
					this.errorMessage = this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Phrase.InvalidSmsCode');
				},
			);
	}
}
